"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @private
 */
exports.PAYOUTS_ENDPOINT = {
    postUserPayout: '/backoffice/payments/{{version}}/users/{{userUuid}}/payouts',
    postCompanyPayout: '/backoffice/payments/{{version}}/companies/{{companyUuid}}/payouts',
};
